
import { translate } from "../common";


/**
 * Supplies a translation helper wired to the shared translate utility.
 * @returns Function that resolves translation ids with optional interpolation values.
 */
export function useTranslation() {

    
    /**
     * Translates the provided id using the global translation catalog.
     * @param id - Translation key to resolve.
     * @param values - Optional interpolation data.
     * @returns Localized string for the key.
     */
    const getTranslation = (id: string, values?: {}) => {
        return translate(id, values);
    }

    return getTranslation;

}